/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./InventoryIcon.vue?vue&type=template&id=840b7962"
import script from "./InventoryIcon.vue?vue&type=script&lang=js"
export * from "./InventoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('840b7962')) {
      api.createRecord('840b7962', component.options)
    } else {
      api.reload('840b7962', component.options)
    }
    module.hot.accept("./InventoryIcon.vue?vue&type=template&id=840b7962", function () {
      api.rerender('840b7962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/InventoryIcon.vue"
export default component.exports